// routes
import { PATH_Admin, PATH_BranchSecretory,PATH_NSM } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// ----------------------------------------------------------------------
const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
const ICONS = {
    dashoard: icon('ic_dashboard'),
    analytics: icon('ic_analytics'),
    home: icon('ic_home'),
    report: icon('ic_report'),
    history: icon('ic_history'),
    settings: icon('ic_settings'),
};

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            // BLOG
            {
                title: 'Home',
                path: PATH_NSM.approve.home,
                icon: ICONS.home,

            },
            {
                title: 'Set Requests',
                path: PATH_NSM.approve.setrequests,
                icon: ICONS.report,

            },


        ],
    }
];
export default navConfig;